import React from "react";
import { Link } from "react-router-dom";

export default function DiningCards() {
  return (
    <section data-testid="dining-cards">
      <div className="grid md:grid-cols-3">
        <div className="sd-dining-card tile-teal" data-testid="dining-newstore">
          <img src="/images/dinein.jpg" alt="New Store" />
          <div className="dining-inner">
            <h2>NEW Store</h2>
            <p>We just opened our new store at Route 31 - 7279 Rochester Road</p>
            <Link
              to="/order?location=rochester"
              className="sd-btn-yellow"
              data-testid="cta-order-rochester"
            >
              Order at Rochester Rd. Shop
            </Link>
          </div>
        </div>

        <div className="sd-dining-card tile-red" data-testid="dining-delivery">
          <img src="/images/takeout.jpg" alt="Delivery" />
          <div className="dining-inner">
            <h2>Delivery</h2>
            <p>Want it ready for pick-up or delivered at home? No problem — order online!</p>
            <Link
              to="/order?location=locust&type=delivery"
              className="sd-btn-red"
              data-testid="cta-order-locust-delivery"
            >
              Order at Locust St. Shop
            </Link>
          </div>
        </div>

        <div className="sd-dining-card tile-green" data-testid="dining-pickup">
          <img src="/images/catering.jpg" alt="Pick-Up" />
          <div className="dining-inner">
            <h2>Pick-Up</h2>
            <p>Want your food ready when you arrive? Order ahead and just pick-up.</p>
            <Link
              to="/order?location=locust&type=pickup"
              className="sd-btn-green"
              data-testid="cta-pickup-locust"
            >
              Pick-Up at Locust St. Shop
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
